import type { StatsigOptions } from '@statsig/react-bindings';

import config from 'js/app/config';
import cookie from 'js/lib/cookie';

/** Statsig Console (dashboard) base URL for toolbar links and documentation. */
export const STATSIG_CONSOLE_URL = 'https://console.statsig.com/';

// Safe to use default client key should provide access to all features and gates in the Statsig dashboard, but it can be overridden by setting a different client key in the request context (e.g. by using a different cookie value that is used to generate the client key).
export const STATSIG_DEFAULT_CLIENT_KEY = 'client-EzRgH1Kpys86D7qYQB4PecL95Y4ArA4XrEi3kXGkS3Q';
const API_BASE_URL = `${config.url.base}api/rest/v1/client-gateway`;

// TODO: ohazda: double check with QA team if this is safe for e2e tests
const shouldPreventAllNetworkTraffic = () => {
  return config.environment === 'development' || (typeof process !== 'undefined' && process.env['NODE_ENV'] === 'test');
};

export const BASE_CLIENT_OPTIONS: StatsigOptions = {
  networkConfig: {
    initializeUrl: `${API_BASE_URL}/init`,
    logEventUrl: `${API_BASE_URL}/eval`,
    networkOverrideFunc: (url, options) =>
      fetch(url, { ...options, headers: { ...options.headers, 'X-CSRF3-Token': cookie.get('CSRF3-Token')! } }),
    preventAllNetworkTraffic: shouldPreventAllNetworkTraffic(),
  },

  loggingEnabled: 'browser-only',
} as const;
